import { InstructorResponsibilityChangesetInput } from "@models/ISchema";
import { IGroupValue, ILeague } from "@modules/vacancies/contextVacancies/ContextVacancies";
import { isUnassignment } from "@modules/vacancies/utils";

const keyFor = (linkId?: string, instructorId?: string) => `${linkId}:${instructorId}`;

export const buildInstructorResponsibilityChangeset = (
  leagues: ILeague[] = [],
  draftGroups: IGroupValue[][] = [],
  targetLinkId?: string,
): InstructorResponsibilityChangesetInput[] => {
  const drafts = draftGroups
    .flatMap(values => values ?? [])
    .filter(value => !targetLinkId || value.linkId === targetLinkId)
    .reduce((map, value) => {
      const instructorId = value?.instructor?.instructor?.id;
      if (instructorId && !isUnassignment(instructorId)) {
        map.set(keyFor(value.linkId, instructorId), value);
      }
      return map;
    }, new Map<string, IGroupValue>());

  return leagues
    .filter(league => !targetLinkId || league.linkId === targetLinkId)
    .flatMap(league =>
      (league.instructors ?? [])
        .filter(instructorLink => !isUnassignment(instructorLink?.instructor?.id))
        .map(instructorLink => {
          const draft = drafts.get(keyFor(league.linkId, instructorLink?.instructor?.id));

          return {
            linkId: league.linkId,
            instructorId: instructorLink?.instructor?.id,
            teachingHoursPercentage:
              draft?.teachingHoursPercentage ?? instructorLink.teachingHoursPercentage,
            paymentPercentage: draft?.paymentPercentage ?? instructorLink.paymentPercentage,
            isPrimary: draft?.isPrimary ?? instructorLink.isPrimary,
          };
        }),
    );
};
